/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input} from '@angular/core';
import {APP_SHARED} from '../app-shared';

@Component({
  standalone: true,
  imports: [...APP_SHARED],
  selector: 'adn-pixel-dimensions',
  template: `
    <span *ngIf="width">{{width}}&times;{{height}}</span>
    <span *ngIf="!width">-</span>
  `
})
export class PixelDimensionsOutputComponent {
  @Input() width: number;
  @Input() height: number;
}
